export default __webpack_public_path__ + "static/media/p5.cec34dd3.JPG";